import axiosClient from './axiosClient';

export default {

  create: (data) => axiosClient.post(`/pratiche`, data),

  update: (id, data) =>
    axiosClient.put(`/pratiche/${id}`, data),

  delete: (id) =>
    axiosClient.delete(`/pratiche/${id}`),

  getById: (id) =>
    axiosClient.get(`/pratiche/${id}`),

  getByAnnoFiscale: (annoFiscaleId) =>
    axiosClient.get(`/pratiche/anno-fiscale/${annoFiscaleId}`),

  getByFascicolo: (fascicoloId) =>
    axiosClient.get(`/pratiche/fascicolo/${fascicoloId}`),

  getPaginated: (params) =>
    axiosClient.get('/pratiche/paginated', { params })

};
